import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShieldCheckIcon, CookieIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const COOKIE_CONSENT_KEY = 'redorg_cookie_consent';
export function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [showPolicy, setShowPolicy] = useState(false);
  const [showCookiesPolicy, setShowCookiesPolicy] = useState(false);
  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay so the banner doesn't flash on page load
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);
  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setVisible(false);
  };
  const handleReject = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'rejected');
    setVisible(false);
  };
  return <>
      <AnimatePresence data-id="element-55">
        {visible && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="fixed bottom-0 inset-x-0 z-[90] p-4 md:p-6" data-id="element-56">
            <div className="max-w-4xl mx-auto bg-brand-navy rounded-2xl shadow-2xl border border-white/10 p-6 md:p-8" data-id="element-57">
              <div className="flex flex-col md:flex-row items-start md:items-center gap-5" data-id="element-58">
                {/* Icon + Text */}
                <div className="flex items-start gap-4 flex-1" data-id="element-59">
                  <div className="w-11 h-11 rounded-full bg-brand-gold/20 flex items-center justify-center shrink-0 mt-0.5" data-id="element-60">
                    <CookieIcon className="w-5 h-5 text-brand-gold" data-id="element-61" />
                  </div>
                  <div data-id="element-62">
                    <h3 className="text-white font-heading font-semibold text-base mb-1.5 flex items-center gap-2" data-id="element-63">
                      <ShieldCheckIcon className="w-4 h-4 text-brand-gold" data-id="element-64" />
                      Protección de Datos y Cookies
                    </h3>
                    <p className="text-white/70 text-sm leading-relaxed" data-id="element-65">
                      Utilizamos cookies propias y de terceros para mejorar tu
                      experiencia de navegación y analizar el tráfico. Al hacer
                      clic en "Aceptar", consientes el uso de todas las cookies.
                      Consulta nuestra{' '}
                      <button onClick={() => setShowPolicy(true)} className="text-brand-gold hover:text-yellow-300 underline underline-offset-2 transition-colors bg-transparent border-none cursor-pointer text-sm p-0 inline font-normal" data-id="element-66">
                        Política de Privacidad
                      </button>{' '}
                      y nuestra{' '}
                      <button onClick={() => setShowCookiesPolicy(true)} className="text-brand-gold hover:text-yellow-300 underline underline-offset-2 transition-colors bg-transparent border-none cursor-pointer text-sm p-0 inline font-normal" data-id="element-67">
                        Política de Cookies
                      </button>{' '}
                      para más información.
                    </p>
                  </div>
                </div>

                {/* Buttons */}
                <div className="flex items-center gap-3 shrink-0 w-full md:w-auto" data-id="element-68">
                  <button onClick={handleReject} className="flex-1 md:flex-none px-5 py-2.5 rounded-full text-sm font-semibold text-white/80 hover:text-white border border-white/20 hover:border-white/40 bg-transparent transition-colors cursor-pointer" data-id="element-69">
                    Rechazar
                  </button>
                  <button onClick={handleAccept} className="flex-1 md:flex-none px-5 py-2.5 rounded-full text-sm font-heading font-semibold bg-brand-gold hover:bg-yellow-400 text-brand-navy transition-colors cursor-pointer border-none shadow-lg" data-id="element-70">
                    Aceptar
                  </button>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>

      <AnimatePresence data-id="element-71">
        {showPolicy && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setShowPolicy(false)} data-id="element-72">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[85vh] flex flex-col overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-73">
              <div className="flex items-center justify-between px-8 py-5 border-b border-gray-200 shrink-0" data-id="element-74">
                <h2 className="text-xl font-heading font-bold text-brand-navy" data-id="element-75">
                  Política de Privacidad y Protección de Datos
                </h2>
                <button onClick={() => setShowPolicy(false)} className="w-9 h-9 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors cursor-pointer border-none" aria-label="Cerrar" data-id="element-76">
                  <XIcon className="w-5 h-5 text-gray-600" data-id="element-77" />
                </button>
              </div>

              <div className="overflow-y-auto px-8 py-6 text-gray-700 text-sm leading-relaxed space-y-6" data-id="element-78">
                <section data-id="element-79">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-80">
                    1. INTRODUCCIÓN
                  </h3>
                  <p data-id="element-81">
                    En REDORG valoramos y respetamos la privacidad de nuestros
                    usuarios. Esta Política de Privacidad describe cómo
                    recopilamos, utilizamos, almacenamos y protegemos los datos
                    personales que usted nos proporciona al utilizar nuestros
                    sitios, APPs, terminales de autoatención u otros sistemas o
                    canales de comunicación.
                  </p>
                </section>
                <section data-id="element-82">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-83">
                    2. RESPONSABLE DEL TRATAMIENTO
                  </h3>
                  <ul className="space-y-1 ml-1" data-id="element-84">
                    <li data-id="element-85">
                      <strong data-id="element-86">Nombre de la entidad:</strong> Fundación REDORG
                    </li>
                    <li data-id="element-87">
                      <strong data-id="element-88">Dirección Legal:</strong> Edificio The Point,
                      Oficina 1803, Puerto Santa Ana, Guayaquil, Ecuador.
                    </li>
                    <li data-id="element-89">
                      <strong data-id="element-90">Correo electrónico de contacto:</strong>{' '}
                      protecciondatos@redorg.net
                    </li>
                  </ul>
                </section>
                <section data-id="element-91">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-92">
                    3. DATOS PERSONALES QUE RECOPILAMOS
                  </h3>
                  <p className="mb-2" data-id="element-93">
                    Podemos recopilar los siguientes datos personales cuando
                    navegas o interactúas con nuestro sitio web u otros canales:
                  </p>
                  <ul className="list-disc ml-6 space-y-1" data-id="element-94">
                    <li data-id="element-95">Nombres y apellidos</li>
                    <li data-id="element-96">Número de Cédula</li>
                    <li data-id="element-97">Correo electrónico</li>
                    <li data-id="element-98">Número de teléfono</li>
                    <li data-id="element-99">
                      Dirección IP y datos de navegación (cookies, ubicación,
                      tipo de navegador)
                    </li>
                    <li data-id="element-100">
                      Información proporcionada mediante formularios de contacto
                      o suscripción
                    </li>
                  </ul>
                </section>
                <section data-id="element-101">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-102">
                    4. FINALIDAD DEL TRATAMIENTO
                  </h3>
                  <p className="mb-2" data-id="element-103">
                    Recopilamos tus datos con las siguientes finalidades:
                  </p>
                  <ul className="list-disc ml-6 space-y-1" data-id="element-104">
                    <li data-id="element-105">
                      Enviar información institucional, boletines, eventos,
                      productos y servicios
                    </li>
                    <li data-id="element-106">
                      Atender consultas o solicitudes realizadas a través de
                      formularios de contacto
                    </li>
                    <li data-id="element-107">Gestionar inscripciones a eventos o programas</li>
                    <li data-id="element-108">
                      Gestionar promociones, beneficios, sistemas de
                      fidelización y otras actividades de marketing
                    </li>
                    <li data-id="element-109">
                      Realizar análisis estadísticos de navegación (uso de
                      cookies)
                    </li>
                    <li data-id="element-110">Cumplir con obligaciones legales y regulatorias</li>
                  </ul>
                </section>
                <section data-id="element-111">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-112">
                    5. LEGITIMACIÓN PARA EL TRATAMIENTO
                  </h3>
                  <p className="mb-2" data-id="element-113">
                    El tratamiento de tus datos se realiza con base en:
                  </p>
                  <ul className="list-disc ml-6 space-y-1" data-id="element-114">
                    <li data-id="element-115">Tu consentimiento expreso</li>
                    <li data-id="element-116">
                      El interés legítimo de REDORG para cumplir su misión
                      institucional
                    </li>
                    <li data-id="element-117">
                      El cumplimiento de obligaciones legales, según la
                      normativa ecuatoriana aplicable (Ley Orgánica de
                      Protección de Datos Personales – LOPDP)
                    </li>
                  </ul>
                </section>
                <section data-id="element-118">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-119">
                    6. DESTINATARIOS DE LOS DATOS
                  </h3>
                  <p className="mb-2" data-id="element-120">
                    Tus datos personales no serán compartidos con terceros,
                    salvo que:
                  </p>
                  <ul className="list-disc ml-6 space-y-1" data-id="element-121">
                    <li data-id="element-122">Tengamos tu consentimiento previo</li>
                    <li data-id="element-123">
                      Sea requerido por autoridad competente conforme a la ley
                    </li>
                    <li data-id="element-124">
                      Se usen herramientas tecnológicas de terceros (por
                      ejemplo, para envío de newsletters, CRM o formularios) con
                      contratos que garantizan la protección de tus datos
                    </li>
                  </ul>
                </section>
                <section data-id="element-125">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-126">
                    7. DERECHOS DEL TITULAR DE LOS DATOS
                  </h3>
                  <p className="mb-2" data-id="element-127">Tienes derecho a:</p>
                  <ul className="list-disc ml-6 space-y-1" data-id="element-128">
                    <li data-id="element-129">Acceder a tus datos personales</li>
                    <li data-id="element-130">Rectificar datos inexactos o incompletos</li>
                    <li data-id="element-131">Eliminar tus datos (cuando proceda)</li>
                    <li data-id="element-132">Oponerte al tratamiento</li>
                    <li data-id="element-133">Solicitar la portabilidad de tus datos</li>
                    <li data-id="element-134">Revocar el consentimiento en cualquier momento</li>
                  </ul>
                  <p className="mt-2" data-id="element-135">
                    Puedes ejercer estos derechos escribiéndonos a{' '}
                    <a href="mailto:protecciondatos@redorg.net" className="text-brand-royal underline hover:text-brand-navy transition-colors" data-id="element-136">
                      protecciondatos@redorg.net
                    </a>
                  </p>
                </section>
                <section data-id="element-137">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-138">
                    8. USO DE COOKIES
                  </h3>
                  <p data-id="element-139">
                    Nuestros sitios utilizan cookies propias y de terceros para
                    mejorar la experiencia de navegación y análisis del tráfico.
                    Puedes aceptar, configurar o rechazar el uso de cookies
                    desde el banner de consentimiento al ingresar al sitio.
                  </p>
                </section>
                <section data-id="element-140">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-141">
                    9. SEGURIDAD DE LA INFORMACIÓN
                  </h3>
                  <p data-id="element-142">
                    REDORG aplica medidas de seguridad técnicas y organizativas
                    adecuadas para proteger tus datos personales contra accesos
                    no autorizados, pérdida, destrucción o alteración.
                  </p>
                </section>
                <section data-id="element-143">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-144">
                    10. CONSERVACIÓN DE LOS DATOS
                  </h3>
                  <p data-id="element-145">
                    Tus datos serán conservados solo durante el tiempo necesario
                    para cumplir con la finalidad para la que fueron recopilados
                    o mientras exista una relación institucional o contractual.
                    Posteriormente serán eliminados o anonimizados, según
                    corresponda.
                  </p>
                </section>
                <section data-id="element-146">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-147">
                    11. CAMBIOS A ESTA POLÍTICA
                  </h3>
                  <p data-id="element-148">
                    Nos reservamos el derecho de modificar esta Política de
                    Privacidad en cualquier momento. Cualquier cambio será
                    publicado con la fecha de actualización correspondiente.
                  </p>
                </section>
                <section data-id="element-149">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-150">
                    12. AUTORIDAD DE CONTROL
                  </h3>
                  <p data-id="element-151">
                    Si consideras que tus derechos no han sido respetados,
                    puedes presentar un reclamo ante la Autoridad de Protección
                    de Datos Personales de Ecuador, la Superintendencia de
                    Protección de Datos Personales.
                  </p>
                </section>
                <section data-id="element-152">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-153">
                    13. VIGENCIA
                  </h3>
                  <p data-id="element-154">
                    La vigencia de estas Políticas de Privacidad y Protección de
                    Datos es desde el 20 de marzo de 2026 y permanecerá vigente
                    hasta que exista una nueva versión que la reemplace.
                  </p>
                </section>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      <AnimatePresence data-id="element-155">
        {showCookiesPolicy && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setShowCookiesPolicy(false)} data-id="element-156">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[85vh] flex flex-col overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-157">
              <div className="flex items-center justify-between px-8 py-5 border-b border-gray-200 shrink-0" data-id="element-158">
                <h2 className="text-xl font-heading font-bold text-brand-navy" data-id="element-159">
                  Política de Cookies
                </h2>
                <button onClick={() => setShowCookiesPolicy(false)} className="w-9 h-9 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors cursor-pointer border-none" aria-label="Cerrar" data-id="element-160">
                  <XIcon className="w-5 h-5 text-gray-600" data-id="element-161" />
                </button>
              </div>

              <div className="overflow-y-auto px-8 py-6 text-gray-700 text-sm leading-relaxed space-y-6" data-id="element-162">
                <section data-id="element-163">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-164">
                    1. INTRODUCCIÓN
                  </h3>
                  <p data-id="element-165">
                    En REDORG utilizamos cookies y tecnologías similares para
                    mejorar la experiencia de navegación en nuestros sitios web,
                    analizar el tráfico, personalizar el contenido y mostrar
                    anuncios relevantes. A continuación, te explicamos qué son
                    las cookies, cómo las usamos y cómo puedes gestionarlas.
                  </p>
                </section>
                <section data-id="element-166">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-167">
                    2. ¿QUÉ SON LAS COOKIES?
                  </h3>
                  <p data-id="element-168">
                    Las cookies son pequeños archivos de texto que un sitio web
                    almacena en tu dispositivo (computadora, celular o tablet)
                    al visitarlo. Estas permiten que el sitio "recuerde" tus
                    acciones o preferencias (como idioma, inicio de sesión,
                    etc.) durante un período de tiempo determinado.
                  </p>
                </section>
                <section data-id="element-169">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-170">
                    3. ¿QUÉ TIPOS DE COOKIES UTILIZAMOS?
                  </h3>
                  <h4 className="font-heading font-semibold text-brand-navy text-sm mt-3 mb-1" data-id="element-171">
                    A. Cookies necesarias (técnicas):
                  </h4>
                  <p data-id="element-172">
                    Permiten la navegación en el sitio web y el uso de sus
                    funciones esenciales. Sin estas cookies, el sitio no puede
                    funcionar correctamente.
                  </p>
                  <h4 className="font-heading font-semibold text-brand-navy text-sm mt-3 mb-1" data-id="element-173">
                    B. Cookies de preferencia o personalización:
                  </h4>
                  <p data-id="element-174">
                    Almacenan información para que el usuario acceda al servicio
                    con características personalizadas, como el idioma o región.
                  </p>
                  <h4 className="font-heading font-semibold text-brand-navy text-sm mt-3 mb-1" data-id="element-175">
                    C. Cookies de análisis o rendimiento:
                  </h4>
                  <p data-id="element-176">
                    Nos permiten conocer el comportamiento de los visitantes
                    para mejorar el sitio. Usamos herramientas como Google
                    Analytics u otras similares.
                  </p>
                  <h4 className="font-heading font-semibold text-brand-navy text-sm mt-3 mb-1" data-id="element-177">
                    D. Cookies de publicidad o marketing:
                  </h4>
                  <p data-id="element-178">
                    Recopilan información sobre tus hábitos de navegación para
                    mostrarte anuncios relevantes en nuestros sitios o en otros.
                  </p>
                </section>
                <section data-id="element-179">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-180">
                    4. ¿CUÁNTO TIEMPO PERMANECEN ACTIVAS?
                  </h3>
                  <ul className="list-disc ml-6 space-y-1" data-id="element-181">
                    <li data-id="element-182">
                      <strong data-id="element-183">Cookies de sesión:</strong> se eliminan al cerrar
                      el navegador.
                    </li>
                    <li data-id="element-184">
                      <strong data-id="element-185">Cookies persistentes:</strong> permanecen en tu
                      dispositivo hasta que las elimines o expiren.
                    </li>
                  </ul>
                </section>
                <section data-id="element-186">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-187">
                    5. ¿CÓMO PUEDES CONTROLAR LAS COOKIES?
                  </h3>
                  <p className="mb-2" data-id="element-188">
                    Al ingresar por primera vez a nuestro sitio, se te mostrará
                    un aviso de cookies. Puedes aceptar todas, rechazarlas o
                    configurarlas según tu preferencia.
                  </p>
                  <p className="mb-2" data-id="element-189">
                    Además, puedes modificar la configuración de cookies desde
                    tu navegador en cualquier momento:
                  </p>
                  <ul className="list-disc ml-6 space-y-1" data-id="element-190">
                    <li data-id="element-191">Google Chrome: Configuración de cookies</li>
                    <li data-id="element-192">Mozilla Firefox: Administrar cookies</li>
                    <li data-id="element-193">Safari: Soporte de Safari</li>
                    <li data-id="element-194">Microsoft Edge: Privacidad y servicios</li>
                  </ul>
                </section>
                <section data-id="element-195">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-196">
                    6. COOKIES DE TERCEROS
                  </h3>
                  <p className="mb-2" data-id="element-197">
                    Algunas cookies pueden ser instaladas por servicios de
                    terceros utilizados en nuestro sitio (como redes sociales,
                    plataformas de video, servicios de estadísticas, etc.). No
                    tenemos control directo sobre ellas. Te recomendamos revisar
                    sus respectivas políticas:
                  </p>
                  <ul className="list-disc ml-6 space-y-1" data-id="element-198">
                    <li data-id="element-199">Google: Política de privacidad</li>
                    <li data-id="element-200">Meta (Facebook / Instagram): Política de cookies</li>
                  </ul>
                </section>
                <section data-id="element-201">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-202">
                    7. CAMBIOS EN ESTA POLÍTICA
                  </h3>
                  <p data-id="element-203">
                    Podemos actualizar esta Política de Cookies en cualquier
                    momento. Te notificaremos en nuestro sitio web cuando se
                    hagan cambios relevantes.
                  </p>
                </section>
                <section data-id="element-204">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-205">
                    8. CONTACTO
                  </h3>
                  <p data-id="element-206">
                    Si tienes dudas sobre nuestra política de cookies, puedes
                    escribirnos a:{' '}
                    <a href="mailto:protecciondatos@redorg.net" className="text-brand-royal underline hover:text-brand-navy transition-colors" data-id="element-207">
                      protecciondatos@redorg.net
                    </a>
                  </p>
                </section>
                <section data-id="element-208">
                  <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-209">
                    9. VIGENCIA
                  </h3>
                  <p data-id="element-210">
                    La vigencia de estas Políticas es desde el 20 de marzo de
                    2026 y permanecerá vigente hasta que exista una nueva
                    versión que la reemplace.
                  </p>
                </section>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}